import { render, staticRenderFns } from "./AccordionIconClose.vue?vue&type=template&id=49d07fdf&"
import script from "./AccordionIconClose.vue?vue&type=script&lang=js&"
export * from "./AccordionIconClose.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports